import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { FileText, Save, Eye, RefreshCcw } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AgreementEditor() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [activeTab, setActiveTab] = useState('sales'); // sales, distance
  const [previewMode, setPreviewMode] = useState(false);
  
  const [salesAgreement, setSalesAgreement] = useState('');
  const [distanceAgreement, setDistanceAgreement] = useState('');

  // Varsayılan sözleşme metinleri
  const defaultSalesAgreement = `EĞİTİM SÖZLEŞMESİ

Aşağıda isim (Unvan) ve adresleri yazılı bulunan KURUM ile KATILIMCI arasında, tamamen kendi istek ve serbest iradeleri ile belirtilen şartlarda "EĞİTİM SÖZLEŞMESİ" yapılmıştır.

MADDE 1: TARAFLAR

1.1.Tarafların ticaret, kimlik ve iletişim bilgileri.

A) KURUMUN

Ünvanı : ÖZEL KARİYER ONLİNE EĞİTİM HİZMETLERİ TİCARET LİMİTED ŞİRKETİ

Adresi : KORKUTREİS MAH. YEŞİLIRMAK CAD. SOMTÜRK İŞ MER. BLOK NO: 17 İÇ KAPI NO: 19 ÇANKAYA / ANKARA

Telefon : 0312 418 18 10

E-mail : egitim@kariyeronline.com.tr

B) KATILIMCININ/ALICININ

TC Kimlik No : {{tc_no}}

Adı Soyadı : {{ad_soyad}}

Doğum Yeri/Yılı : {{dogum_yeri}} / {{dogum_yili}}

Telefon : {{telefon}}

E-Mail Adresi : {{email}}

Adres : {{adres}}

Sertifika Adı : {{grup_adi}}



1.2.Sözleşme konusu hizmete ilişkin siparişini tamamlayan ve onaylayan kişi işbu sözleşme çerçevesinde ''ALICI'' sıfatını kazanır ve sözleşme ile doğacak olan hizmet bedeli, kargo ücreti, vergi ödemesi gibi giderleri üstlenmeyi kabul ettiğini taahhüt etmiş olur.

MADDE 2: KONU
2.1.İşbu sözleşmenin konusu; ALICI'nın SATICI'ya uzaktan iletişim yoluyla siparişini verdiği eğitimin özellikleri ile www.kariyeronline.com.tr ücreti belirtilen ürünün(dijital içerik) satışı, teslimi, iadesi, uyuşmazlık halleri ile ilgili olarak 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmelere Dair Yönetmelik hükümleri gereğince tarafların hak ve yükümlülüklerini düzenler.
2.2.İşbu sözleşme ile alıcı; satıcının adresi, unvanı, sözleşme konusu ürünün özelliklerini, vergi ve kargo ücreti dahil ürün bedelini, ödeme şeklini, sözleşmeden doğan yükümlülüklerini, cayma hakkının kullanılmasına ilişkin şartları, uyuşmazlık halinde hangi makamların yetkili olacağını, site üzerinde konuya ilişkin bilgilerin açık bir şekilde paylaşıldığını ve kendisinin bu bilgileri okuyup anladığını, sözleşme metnini incelediğini ve siparişini bu bilgiler üzerine tamamladığını, ürün ile ilgili kampanya bilgilerini ve detayları ortamına uygun bir şekilde site üzerinde paylaşıldığını ve kendisinin bu bilgiler çerçevesinde ürünü seçtiğini, işbu sözleşme metnini okuduğunu ve Türk Borçlar Kanunu çerçevesinde hür ve açık iradesi ile onayladığını kabul eder.


MADDE 3: SÖZLEŞME KONUSU ÜRÜN BİLGİLERİ
3.1. Sözleşmeye konu ürünün bilgileri, satıcıya ait internet sitesinde açıkça belirtilmiştir. Ürün bir kampanya kapsamında ise söz konusu kampanya şartları ve tarihleri ürüne ilişkin bilgiler arasında paylaşılmış olup, alıcının kampanyadan yararlanmasında, siparişi oluşturmaya başladığı tarih ve saat değil, siparişini bu sözleşme hükümlerini okuyup kabul ettikten sonra onayladığı tarih ve saat dikkate alınır. Ödeme zamanı ve şekli işbu sözleşme devamında belirtilmiş olup tarafların açık iradeleri doğrultusunda ödeme planı oluşturulmuştur.
3.2.Sözleşme konusu ürünün/hizmetin vergileri dahil satış fiyatı aşağıda belirtilmiştir.
3.3.Sözleşme konusu ürün/hizmet alıcının talepleri doğrultusunda sevkiyatı gerçekleştirilebilecek bir materyal (CD, DVD, FLASHBELLEK, HARD DİSK, vb.) ile alıcıya ulaştırılacak ise, sevkiyata ilişkin kargo ücreti alıcı tarafından ödenecektir. Kargo fiyatına ilişkin kampanya yapma hakkı satıcıya aittir. Bu talep doğrultusunda sağlanacak olan hizmete ilişkin teslimat hükümleri işbu sözleşmenin devamında düzenlenmiş bulunmaktadır. Teslim ile ilgili hükümler sadece sevkiyatın yapılması istenen hallerde geçerli olacak olup, dijital veri yoluyla hizmetin/ürünün anında ifa edileceği hallerde sevkiyat yolu ile teslim sözleşme konusu değildir.


MADDE 5: SÖZLEŞME KURULMA TARİHİ ve MÜCBİR NEDENLER
5.1.Sözleşme alıcının mesafeli satış sözleşmesini okuyup onayladığı an itibariyle kurulmuş sayılır.
5.2.Sözleşmenin imzalandığı tarihte mevcut olmayan veya öngörülmeyen, tarafların kontrolleri dışında gelişen, ortaya çıkmasıyla taraflardan birinin ya da her ikisinin de sözleşme ile yüklendikleri borç ve sorumluluklarını kısmen ya da tamamen yerine getirmelerini ya da bunları zamanında yerine getirmelerini olanaksızlaştıran durumlar, mücbir sebep (Doğal afet, savaş, terör, ayaklanma, değişen mevzuat hükümleri, el koyma veya grev, lokavt, üretim ve iletişim tesislerinde önemli ölçüde arıza vb.) olarak kabul edilecektir. Mücbir sebep şahsında gerçekleşen taraf, diğer tarafa durumu derhal ve yazılı olarak bildirecektir. Mücbir sebebin devamı esnasında tarafların edimlerini yerine getirememelerinden dolayı herhangi bir sorumlulukları doğmayacaktır. İşbu mücbir sebep durumu 30 (otuz) gün süreyle devam ederse, taraflardan her birinin, tek taraflı olarak fesih hakkı doğmuş olacaktır.



MADDE 6: GENEL HÜKÜMLER
6.1.İşbu sözleşme ile alıcı; sözleşme konusu ürünü sitede incelediğini ve belirtilen özellikleri ile kabul ettiğini, ürünün ödemesini şartlara uygun bir şekilde yapmayı, satıcının adres bilgilerini edindiğini, kendisi tarafından verilen bilgilerin doğru olduğunu aksi halde yaşanacak sıkıntılarda kendisinin sorumlu olacağını, ürünün teslimatından sonra taraflarca belirlenen ödeme gününce ücretinin ödeneceğini alıcı kabul ve taahhüt eder.
6.2.Satıcı kendisine işbu sözleşme ile yüklenen edimleri, 6502 Sayılı Tüketicinin Korunması Hakkında Kanun ile Mesafeli Sözleşmeler Yönetmeliği'nin kendisine yüklediği yükümlülükleri, mücbir sebepler istisna olmak kaydıyla, yerine getireceğini taahhüt eder.
6.3.Ürünün sözleşmede belirtilen fiyatına vergilerin dahil edilip edilmeyeceği açıkça belirtilmiştir. Vergilerin ödenmesi her halde alıcıya ait olup bu miktar toplam ödenecek fiyata dahil edilerek kendisinden tahsil edilecektir.
6.4.Ürün/hizmet, alıcının talepleri doğrultusunda maddi ortamda (cd,flash vs.) sevkiyatı yapılarak alıcıya ulaştırılması kararlaştırılmış ise, 30 gün içerisinde alıcının belirtmiş olduğu adrese teslim edilecektir. Bu süre zarfında eline geçmeyen ürün için alıcının siparişi iptal etme ve sözleşmeyi feshetme hakkı saklıdır.
6.5.Alıcının adres, fatura, teslimat adresi ve ödeme bilgilerinde hata veya uyuşmazlık olması halinde satıcı siparişin oluşturulmasını ve sevkiyatını askıya alarak alıcı ile irtibat kuracaktır. Alıcının vermiş olduğu bilgiler vasıtasıyla kendisi ile irtibat kurulamaması halinde satıcı sitede yer alan siparişe ilişkin detaylarda durumu belirterek siparişi iki tarafın da zarar görmemesi için iptal edebilir.
6.6.Siparişin hazırlanması veya sevkiyatı aşamasında yaşanabilecek aksaklıklar halinde satıcı alıcıyı 3 iş günü içerisinde bilgilendirecektir.
6.7.Sipariş yukarıda sayılan nedenler ile iptal edilecek olur ise alıcı tarafından yapılmış bir ödeme bulunması halinde ilgili tutar kendisine 14 iş günü içerisinde iade edilecektir.
6.8.Mesafeli eğitim satış sözleşmesinin ihtivası nedeniyle satıcı; alıcının sözleşme kurma ehliyetinin olup olmadığını yalnızca site üzerinden paylaştığı bilgiler ve yaptığı onaylamalar ile anlayabilecektir. Bu sebeple siparişi oluşturan kişinin veya alıcının sözleşme kurma ehliyetine sahip olmaması nedeniyle oluşabilecek zararlardan satıcı sorumlu değildir. Satıcıya bu sebeplerle herhangi bir sorumluluk yüklenemez ve gerek ödemenin yapılamayacağına gerekse ürünün iadesinde oluşabilecek kusurlara katlanması kendisinden beklenemez ve bu durumlarda alıcı ve yasal temsilcisi sorumludur.
6.9.Satıcı siparişi oluşturulan ürünün, sitede belirtilen özeliklere haiz olarak siparişe uygun bir şekilde hazırlanmasını; varsa kullanım kılavuzu ve garanti belgesini ürün ile birlikte alıcıya ulaştırmayı; ürünün alıcıya ulaştırılmasında kendisinde bulunması gereken iyi niyet ve dürüstlük vasıflarına uyacağını; ürünün kendi himayesinden çıkarken sipariş detaylarına uygun olacağını taahhüt eder.
6.10.Satıcı ürünün sevkiyatına ilişkin olarak alıcının veya gösterdiği bir üçüncü kişinin eline ulaşması anına kadar, kanun ve yönetmelik gereğince, teslim ile sorumludur. Teslim PTT Kargo şirketi ile Alıcının işbu sözleşmede belirttiği adresine yapılacaktır. Alıcı yukarıda belirtilen anlaşmalı kargo şirketinden başka bir firma ile teslimin yapılmasını istemiş ise, satıcı sadece alıcının nakliye yapılmasını istediği kargo firmasına siparişin tesliminden sorumludur. Siparişin kargoya tesliminden sonra oluşabilecek aksaklıklardan satıcı sorumlu değildir. Kargo firması ile kurulan ilişki alıcının siparişi oluşturduğu esnada yapmış olduğu tercihler doğrultusunda alıcı adına ve hesabına kurulacaktır.
6.13.Sözleşme konusu ürün/ürünler, Alıcı'dan başka bir kişi/kuruluşa teslim edilecek ise, teslim edilecek kişi/kuruluşun teslimatı kabul etmemesinden Satıcı sorumlu tutulamaz.
6.14.Satıcı mücbir sebeplerin varlığı nedeniyle sipariş konusu ürünün alıcıya ulaştırılamayacağını düşünüyor ise bu durumu alıcıya derhal bildirir. Alıcı bildirim karşısında siparişin iptal edilerek ücretin iade edilmesini, siparişin sevkiyatın yapılabileceği tarihe kadar ertelenmesini veya siparişte yer alan ürünün sevkiyatı yapılabilecek başka bir ürün ile değiştirilmesini isteyebilir. Ücretin iade edilmesi aşamasında banka hesaplarında yapılacak işlemlerde banka tarafından yaşanan gecikmelerden satıcı sorumlu değildir.
6.15.Alıcı, satıcı ile paylaşmış olduğu telefon ve mail adreslerine kampanya bilgisi ve reklam gönderilmesini kabul eder. Bu bilgilerin kendisi ile paylaşılmasından vazgeçilmesini istediği taktirde satıcı ile irtibat kurarak bilgi paylaşımının durdurulmasını isteyebilir.
6.16.Alıcı, satıcı ile ilişki kurduğu internet sitesini kullanırken kendisinden beklenen özeni gösterir. Siteyi kullanması sırasında yaşanabilecek aksaklıklar ve sıkıntılardan kendisi sorumlu olup satıcının cezai ve hukuki sorunluluğu bulunmadığını kabul eder.
6.17.Satıcının ürünlerini tanıttığı ve sattığı internet sitesine ulaşım, üçüncü kişiler tarafından dizayn edilmiş ve kullanılan siteler üzerinden link paylaşılarak sağlanabilir. Bu gibi durumlarda satıcı, üçüncü kişilerin himayesinde olan sitelerde paylaşılan linkin güvenliğinde sorumlu değildir. Satıcıya ait olduğu düşünülerek ziyaret edilen linkler sonucunda alıcının uğradığı zararlardan alıcı kendisi sorumludur. Bu sitelerde karşılaşılan reklamlar ile satıcının kendi sitesinde yer alan tanıtımlar arasında farklılıklar olduğu taktirde satıcının kendi sitesi esas alınacak olmasını alıcı kabul eder.
6.18.Alıcı, satıcıya ait internet sitesi üzerinden satıcıyı ve üçüncü kişileri rahatsız edecek ve kişilik haklarını zedeleyecek paylaşımlarda bulunamaz, siteyi hukuki amacının dışında bir amaç ile kullanamaz, satıcı ve üçüncü kişilere zararı dokunacak şekilde virüs, program ve benzeri sanal zarar vericileri siteye yükleyemez. Bu gibi durumlarda doğacak olan zararlardan alıcı kendisinin sorumlu olacağını kabul ve taahhüt eder. Satıcının bu gibi zararları hukuk yoluna taşıması halinde de alıcı yine kendisi sorumludur.
6.19.Alıcı, satıcıdan vergi indiriminde bulunmasını bekleyemez ve ürünün satımı sırasında doğacak olan verginin kendisi tarafından ödenmeyeceğini iddia edemez.
6.22.Ürün/ürünlerin tesliminden sonra Alıcı'ya ait kredi kartının Alıcı'nın kusurundan kaynaklanmayan bir şekilde yetkisiz kişilerce haksız veya hukuka aykırı olarak kullanılması nedeni ile ilgili Banka veya finans kuruluşunun ürün/ürünlerin bedelini Satıcı'ya ödememesi halinde, Alıcı kendisine teslim edilmiş olması kaydıyla ürün/ürünleri 5 (Beş) iş günü içinde teslimat giderleri kendisine ait olacak şekilde Satıcı'ya göndermekle yükümlüdür. Aksi takdirde ürün/ürünlerin bedelini ödemekle yükümlü olacaktır.
6.23.Katılımcı/alıcı, ürünün/hizmetin kendisine kalıcı veri saklayıcısı kullanılmak suretiyle iletilmesini istemiş ise cayma hakkına ilişkin hükümler işbu sözleşmenin 9. Maddesinde düzenlenmiş olup katılımcı/alıcı işbu mesafeli satış sözleşmesini onayladığı anda gerekli bilgileri aldığını kabul ve beyan eder.
6.23.Ürün/hizmet, alıcı/katılımcıya, esas olarak internet üzerinden iletilecek olup, teslime ilişkin hükümler, alıcının talebi doğrultusunda hizmetin/ürünün kendisine kalıcı veri saklayıcısı ile iletilmesi istendiği hallerde uygulanacaktır. Bu doğrultuda internet üzerinden dijital veri yoluyla sağlanacak hizmetin/ürünün ifa türü anında ifadır. Katılımcı/alıcının adına tanımlanan kullanıcı adı ve şifresi ile www.kariyerpaneli.com sitesi üzerinden giriş yaparak ön bilgilendirme formunu ve mesafeli satış sözleşmesini onayladığı anda ifa kurum tarafından gerçekleştirilmiş olacaktır. Bu doğrultuda gerçekleşen ifa neticesinde alıcının cayma hakkı işbu sözleşmenin 9. Maddesinde ele alınmış olup katılımcı/alıcı işbu mesafeli satış sözleşmesini onayladığı anda gerekli bilgileri aldığını kabul ve beyan eder.

MADDE 7: ÖDEME ŞEKLİ
7.1. Kredi Kartı ile Ödeme: Alıcı'nın Kredi kartı ile ödemede bulunabilmesi için kredi kartı bilgilerini tam ve eksiksiz olarak ilgili kısımlardaki bölüme doldurması gerekmektedir. Kredi kartı ile tek çekimde ödemede bulunulabileceği gibi, kampanyalar kapsamında belirlenebilecek sayıdaki takside bölünmek suretiyle de ödeme yapılabilir. Banka kampanyalar düzenleyerek Alıcı'nın seçtiği taksit adedinin daha üstünde bir taksit adedi uygulayabilir, taksit öteleme gibi hizmetler sunulabilir. Bu tür kampanyalar Banka'nın inisiyatifindedir.

7.2. Havale ile Ödeme: Alıcı Havale ile ödemede bulunmak isterse, Ziraat Bankası; Şube Kodu : 0795 Hesap : 83412657-5001 IBAN : TR 58 0001 0007 9583 4126 5750 01 ya da Garanti Bankası Şube Kodu : 082 Hesap No : 6291506 IBAN : TR 61 0006 2000 0820 0006 2915 olan hesabına havale yapacaktır.


7.3. Diğer yandan vadeli satışların sadece Bankalara ait kredi kartları ile yapılması nedeniyle, Alıcı, ilgili faiz oranlarını ve temerrüt faizi ile ilgili bilgileri bankasından ayrıca teyit edeceğini, yürürlükte bulunan mevzuat hükümleri gereğince faiz ve temerrüt faizi ile ilgili hükümlerin Banka ve Alıcı arasındaki kredi kartı Sözleşmesi kapsamında uygulanacağını kabul, beyan ve taahhüt eder.


MADDE 8: İADE PROSEDÜRÜ
8.1.Kredi Kartına İade Prosedürü: Alıcı'nın cayma hakkını kullandığı durumlarda ya da siparişe konu olan ürünün çeşitli sebeplerle tedarik edilememesi veya Tüketici Sorunları Hakem Heyeti kararları ile Alıcı'ya bedel iadesine karar verilen durumlarda, alışveriş kredi kartı ile tek çekim veya taksitli olarak yapılmışsa, kredi kartına iade prosedürü banka tarafından belirlenecektir. Alıcı, ilgili banka tarafından uygulanacak iade prosedürünü peşinen kabul ettiğini beyan eder.
8.2.Havale Ödeme Seçeneklerinde İade Prosedürü: havale ödeme seçeneklerinde iade Alıcı'dan Banka hesap bilgileri istenerek, Alıcı'nın belirttiği hesaba (hesabın fatura adresindeki kişinin adına veya kullanıcı üyenin adına olması şarttır) havale şeklinde yapılacaktır.


MADDE 9: CAYMA HAKKI

9.1.6502 sayılı Tüketicinin Korunması Hakkında Kanun'una bağlı kalınarak ve 27/11/2014 tarihli 29188 sayılı Resmi Gazetede yayımlanan Mesafeli Sözleşmeler Yönetmeliği'nin 2. Maddesinde dijital içerik; '' Bilgisayar programı, uygulama, oyun, müzik, video ve metin gibi dijital şekilde sunulan her türlü veri.'' Şeklinde, kalıcı veri saklayıcısı; '' Tüketicinin gönderdiği veya kendisine gönderilen bilgiyi, bu bilginin amacına uygun olarak makul bir süre incelemesine elverecek şekilde kaydedilmesini ve değiştirilmeden kopyalanmasını sağlayan ve bu bilgiye aynen ulaşılmasına imkan veren kısa mesaj, elektronik posta, internet, disk, CD, DVD, hafıza kartı ve benzeri her türlü araç veya ortamı.'' Şeklinde tanımlanmıştır. İşbu sözleşme konusu ürün/hizmet, yönetmelikte tanımlanan dijital veri veya kalıcı veri saklayıcısı ile iletilecek ürün veya hizmettir.
9.2.Mesafeli Sözleşmeler Yönetmeliği'nin 15. Maddesinin 1. Fıkrasının ''ğ'' bendi '' Elektronik ortamda anında ifa edilen hizmetler veya tüketiciye anında teslim edilen gayrimaddi mallara ilişkin sözleşmeler.'' uyarınca, katılımcının almış olduğu ürün veya hizmeti iade ederek sözleşmeden CAYMA HAKKI BULUNMAMAKTADIR. Katılımcı işbu sözleşmeyi okuyarak onaylaması ile yasal düzenlemeler gereği cayma hakkının OLMADIĞINI, kabul ve beyan etmiş olur.
9.3. Ürün veya hizmetin katılımcı/alıcıya iletilmesi, katılımcı veya alıcının talepleri doğrultusunda, yönetmelikte tanımlanan kalıcı veri saklayıcısı ile sağlanacak ise, Mesafeli Sözleşmeler Yönetmeliği'nin 15. Maddesinin 1. Fıkrasının ''e'' bendi '' Malın tesliminden sonra ambalaj, bant, mühür, paket gibi koruyucu unsurları açılmış olması halinde maddi ortamda sunulan kitap, dijital içerik ve bilgisayar sarf malzemelerine ilişkin sözleşmeler.'' uyarınca, bu ürünlerin ambalajının açılmış olması halinde İADESİ KABUL EDİLMEYECEK, bu katılımcı/alıcı CAYMA HAKKINI KULLANAMAYACAKTIR. Bu durumda cayma hakkının on dört gün içerisinde kullanılabilmesi için, iletilmesi istenen hizmete ilişkin kalıcı veri saklayıcısını paketi açılmamış olması, ambalajının bozulmamış olması gerekmektedir. Bu madde çerçevesinde hareket etmeyen alıcı/katılımcı cayma hakkını KAYBEDECEĞİNİ ÖĞRENDİĞİNİ işbu sözleşmeyi onaylayarak kabul ve beyan etmiş olur.
9.4. Alıcı talepleri doğrultusunda ürün veya hizmetler alıcıya yönetmelikte tanımlanan kalıcı veri saklayıcısı ile sağlanacaksa (cd, flash bellek dvd vs.) işbu sözleşmenin 9.3. maddesi kapsamında ürünlerin ambalajının açılmış olması halinde alıcı cayma hakkını kullanmak isterse, bu hakkını kullandığını satıcıya yazılı bir şekilde e-mail, telefon veya faks yoluyla bildirirken açıkça ''Cayma Hakkını Kullandığını'' beyan edeceğini taahhüt eder.
9.5.Cayma hakkının kullanılması ile iade edilmesi gündeme gelen ücret, sözleşmenin kurulması aşamasında tahsil edilen ücrettir. İade işlemlerinin yapılacağı dönemde kampanya süresinin bitmesi veya ürünün piyasa değerinin artması nedeniyle ürünün sitede belirtilen fiyatında bir fazlalık var ise alıcı bu değeri isteyemez. Ayrıca cayma hakkının kullanılması sırasında alıcı tarafından yapılmış her hangi bir ödeme yoksa, alıcı bir ücret ödenmesine talep edemeyecek olup, almış olduğu ürün/hizmeti işbu sözleşme kapsamında iade etmekle yükümlüdür.

MADDE 10: DİĞER HÜKÜMLER
12.1.Alıcı, işbu Sözleşme'de ve ayrılmaz parçasını oluşturan sipariş-sözleşme ön bilgilendirmelerinde (İNTERNET SİTESİ'nde) yazılı tüm koşulları ve açıklamaları okuduğunu, satışa konu Ürün/Ürün'lerin temel özellik-nitelikleri, satış fiyatı, ödeme şekli, teslimat koşulları, Satıcı ve satışa konu Ürün ile ilgili diğer tüm ön bilgiler-bilgilendirmeler ve cayma hakkı ile kişisel bilgiler-elektronik iletişim koşulları dahil bu Sözleşme ile Ön Bilgilendirme formunda yazılı bütün hususlar konusunda önceden bilgi sahibi olduğunu, tamamını İNTERNET SİTESİ'nde elektronik ortamda gördüğünü ve yine tüm bunlara elektronik ortamda teyit-onay-kabul-iznini vererek Ürün'ü sipariş ile işbu Sözleşme hükümlerini kabul ettiğini kabul ve beyan eder.
12.2.www.kariyeronline.com sitesinde yer alan ön bilgilendirme ve fatura işbu Sözleşmenin ayrılmaz parçalarıdır. Sipariş gerçekleştiği anda ALICI bu Sözleşme'nin tüm koşullarını kabul etmiş sayılır. Ürünün cinsi ve türü, miktarı, marka/modeli, rengi ve tüm vergiler dahil satış bedeli www.kariyeronline.com adlı web sitesindeki ürünün tanıtım sayfasında yer alan bilgilerde ve işbu Sözleşme'nin ayrılmaz parçası sayılan faturada belirtildiği gibidir. SATICI teknik nedenlerden kaynaklanan fiyat güncelleme hatalarından sorumlu değildir.
12.3.Gerek söz konusu ön bilgilendirmeler, gerek bu Sözleşme, Alıcı'nın Satıcı 'ya bildirdiği yukarıdaki elektronik posta (mail) adresine de gönderilmekte, anılan elektronik postada siparişin alındığı teyidi sipariş özeti ile birlikte ayrıca yer almaktadır.


MADDE 11: YETKİLİ MAHKEME
13.1.Alıcı işbu Sözleşmeden kaynaklanabilecek şikayet ve itiraz başvurularını, Gümrük ve Sanayi Bakanlığınca her yıl Aralık ayında belirlenen parasal sınırlar dâhilinde ürünü satın aldığı veya ikametgâhının bulunduğu yerdeki tüketici sorunları hakem heyetine veya tüketici mahkemesine yapabilir.
13.2.Alıcının da tacir olduğu veya tacir sayıldığı durumlarda veya alıcının vermiş olduğu siparişten ticari amaçla satıcı ile ilişki kurduğu anlaşılıyor ise sözleşme çerçevesinde doğacak uyuşmazlıklarda satıcının adresinin bulunduğu yerdeki ticaret mahkemeleri yetkilidir.


MADDE 12: YÜRÜRLÜK
14.1.Satıcı site üzerinde, alıcı tarafından işbu sözleşmenin okunduğunu ve kabul edildiğini beyan edeceği bir yazılım oluşturmayı üstlenir. Alıcının sözleşmeyi okuyup kabul etmesi ile sözleşme kurulmuş sayılır ve tarafların karşılıklı belirleyeceği ödeme planı dahilinde alıcı ürün/hizmetin ücretini ödeme yükümlülüğü altına girer.
14.2.Alıcı sözleşme kurulmadan önce bir iletişim vasıtasıyla satıcı ile irtibat kurmuş ve akabinde site üzerinden işlem yapmış ise öncesinde yapmış olduğu görüşmeler hüküm ve sonuç doğurmayacak olup işbu sözleşme ile alıcı ve satıcı birbirlerine karşı yükümlülük altına gireceklerdir.



MADDE 13: EĞİTİM ÜCRETİ VE ÖDEME PLANI

{{odeme_plani}}


6 sayfa ve 13 maddeden oluşan işbu eğitim hizmetine ilişkin mesafeli satış sözleşmesi {{tarih}} tarihinde, taraflarca iki nüsha olarak tanzim edilip, bilinçli bir tüketici yaklaşımıyla, mesafeli iletişim araçlarına uygun bir şekilde kabul edilmiş, imza altına alınmıştır.

KATILIMCI

TARİH

    {{ad_soyad}}

    {{tarih}}



ÖZEL KARİYER ONLİNE EĞİTİM HİZMETLERİ TİCARET LİMİTED ŞİRKETİ BANKA HESAP BİLGİLERİ

ZİRAAT BANKASI
IBAN : TR 58 0001 0007 9583 4126 5750 01
ŞUBE KODU : 0795
Hesap Adı : ÖZEL KARİYER ONLİNE EGT. BİL. HİZM. TİC. LTD. ŞTİ

GARANTİ BANKASI
IBAN : TR 61 0006 2000 0820 0006 2915 06
ŞUBE KODU: 082
Hesap Adı : ÖZEL KARİYER ONLİNE EGT. BİL. HİZM. TİC. LTD. ŞTİ`;

  const defaultDistanceAgreement = `MESAFELİ SATIŞ SÖZLEŞMESİ

6502 Sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği kapsamında düzenlenmiştir.

Sözleşme Tarihi: {{tarih}}

1. SATICI BİLGİLERİ
Ünvan: AirAcademia Eğitim Hizmetleri
Adres: İstanbul, Türkiye
E-posta: info@airacademia.com
Telefon: +90 xxx xxx xx xx

2. ALICI BİLGİLERİ
Ad Soyad: {{ad_soyad}}
E-posta: {{email}}
Telefon: {{telefon}}
Adres: {{adres}}
T.C. Kimlik No: {{tc_no}}

3. SÖZLEŞMENİN KONUSU
İşbu sözleşmenin konusu, SATICI'nın, ALICI'ya satışını yaptığı online eğitim hizmetinin satışı ve teslimi ile ilgili olarak 6502 sayılı Tüketicinin Korunması Hakkında Kanun hükümleri gereğince tarafların hak ve yükümlülüklerinin saptanmasıdır.

4. HİZMETİN TEMEL ÖZELLİKLERİ
4.1. Hizmet Türü: Online Havacılık İngilizce Eğitimi
4.2. İçerik: Video dersler, interaktif alıştırmalar, testler
4.3. Erişim: 7/24 online platform erişimi
4.4. Süre: Üyelik süresince sınırsız erişim

5. HİZMETİN FİYATI
Toplam Tutar: {{toplam_ucret}} TL (KDV Dahil)
Ödeme Durumu: {{odeme_durumu}}

6. ÖDEME ŞEKLİ
Kredi kartı, banka kartı veya havale/EFT ile ödeme yapılabilir.
Taksitli ödemelerde (2, 3, 4, 6, 9 taksit) ek masraf alınmaz.

7. TESLİMAT
Dijital hizmet olması sebebiyle, ödemenin onaylanmasının ardından ALICI'nın hesabı anında aktif edilir.

8. CAYMA HAKKI
8.1. ALICI, dijital içerik hizmetinin ifasına başlandığı andan itibaren cayma hakkını kullanamaz.
8.2. ALICI, hizmeti satın almadan önce bu durumu kabul etmiş sayılır.

9. GENEL HÜKÜMLER
9.1. ALICI, bu sözleşmeyi elektronik ortamda onaylayarak tüm koşulları kabul etmiş sayılır.
9.2. SATICI, hizmet kapsamını önceden haber vererek değiştirebilir.

10. YETKİLİ MAHKEME
Uyuşmazlıklarda Tüketici Hakem Heyetleri ve Tüketici Mahkemeleri yetkilidir.

11. YÜRÜRLÜK
Bu sözleşme, ALICI tarafından elektronik ortamda onaylandığı tarihte yürürlüğe girer.

İşbu sözleşme, taraflarca okunarak elektronik ortamda kabul edilmiştir.`;

  useEffect(() => {
    loadAgreements();
  }, []);

  const loadAgreements = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API}/admin/agreements`, { withCredentials: true });
      if (response.data) {
        setSalesAgreement(response.data.sales_agreement || defaultSalesAgreement);
        setDistanceAgreement(response.data.distance_agreement || defaultDistanceAgreement);
      }
    } catch (error) {
      console.error('Error loading agreements:', error);
      // Varsayılan metinleri kullan
      setSalesAgreement(defaultSalesAgreement);
      setDistanceAgreement(defaultDistanceAgreement);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      await axios.post(`${API}/admin/agreements`, {
        sales_agreement: salesAgreement,
        distance_agreement: distanceAgreement
      }, { withCredentials: true });
      toast.success('Sözleşmeler kaydedildi');
    } catch (error) {
      console.error('Error saving agreements:', error);
      toast.error('Kaydetme hatası');
    } finally {
      setSaving(false);
    }
  };

  const handleReset = (type) => {
    if (window.confirm('Varsayılan metne dönmek istediğinize emin misiniz?')) {
      if (type === 'sales') {
        setSalesAgreement(defaultSalesAgreement);
      } else {
        setDistanceAgreement(defaultDistanceAgreement);
      }
      toast.success('Varsayılan metin yüklendi');
    }
  };

  // Önizleme için değişkenleri örnek değerlerle değiştir
  const getPreviewText = (text) => {
    return text
      .replace(/\{\{tarih\}\}/g, new Date().toLocaleDateString('tr-TR'))
      .replace(/\{\{ad_soyad\}\}/g, 'Ahmet Yılmaz')
      .replace(/\{\{email\}\}/g, 'ahmet@example.com')
      .replace(/\{\{telefon\}\}/g, '0532 123 45 67')
      .replace(/\{\{adres\}\}/g, 'Örnek Mah. Test Sok. No:1')
      .replace(/\{\{tc_no\}\}/g, '12345678901')
      .replace(/\{\{dogum_yeri\}\}/g, 'Ankara')
      .replace(/\{\{dogum_yili\}\}/g, '1995')
      .replace(/\{\{grup_adi\}\}/g, 'Kabin Memurluğu Eğitimi')
      .replace(/\{\{odeme_plani\}\}/g, 'Toplam: 15.000 TL\nÖdenen: 5.000 TL\nKalan: 10.000 TL')
      .replace(/\{\{toplam_ucret\}\}/g, '15.000')
      .replace(/\{\{odenen_tutar\}\}/g, '5.000')
      .replace(/\{\{kalan_tutar\}\}/g, '10.000')
      .replace(/\{\{odeme_durumu\}\}/g, '5.000 TL ödenmiştir');
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center p-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Sözleşme Yönetimi</h2>
          <p className="text-gray-500 text-sm mt-1">Satış ve mesafeli satış sözleşmelerini düzenleyin</p>
        </div>
        <div className="flex gap-2">
          <Button 
            variant="outline" 
            onClick={() => setPreviewMode(!previewMode)}
            className="gap-2"
          >
            <Eye className="w-4 h-4" />
            {previewMode ? 'Düzenleme' : 'Önizleme'}
          </Button>
          <Button onClick={handleSave} disabled={saving} className="gap-2 bg-blue-600 hover:bg-blue-700">
            <Save className="w-4 h-4" />
            {saving ? 'Kaydediliyor...' : 'Kaydet'}
          </Button>
        </div>
      </div>

      {/* Değişken Açıklaması */}
      <Card className="bg-blue-50 border-blue-200">
        <CardContent className="p-4">
          <h4 className="font-medium text-blue-800 mb-2">Kullanılabilir Değişkenler</h4>
          <div className="flex flex-wrap gap-2 text-sm">
            {[
              { var: '{{tarih}}', desc: 'Sözleşme tarihi' },
              { var: '{{ad_soyad}}', desc: 'Öğrenci adı' },
              { var: '{{email}}', desc: 'E-posta' },
              { var: '{{telefon}}', desc: 'Telefon' },
              { var: '{{adres}}', desc: 'Adres' },
              { var: '{{tc_no}}', desc: 'TC Kimlik' },
              { var: '{{dogum_yeri}}', desc: 'Doğum yeri' },
              { var: '{{dogum_yili}}', desc: 'Doğum yılı' },
              { var: '{{grup_adi}}', desc: 'Sertifika/Eğitim adı' },
              { var: '{{odeme_plani}}', desc: 'Ödeme planı' },
              { var: '{{toplam_ucret}}', desc: 'Toplam ücret' },
              { var: '{{odenen_tutar}}', desc: 'Ödenen' },
              { var: '{{kalan_tutar}}', desc: 'Kalan' },
              { var: '{{odeme_durumu}}', desc: 'Ödeme durumu' }
            ].map(item => (
              <span key={item.var} className="px-2 py-1 bg-white rounded border border-blue-200 text-blue-700">
                <code className="font-mono">{item.var}</code>
                <span className="text-blue-500 ml-1 text-xs">({item.desc})</span>
              </span>
            ))}
          </div>
        </CardContent>
      </Card>

      {/* Tabs */}
      <div className="flex gap-2 border-b">
        <button
          onClick={() => setActiveTab('sales')}
          className={`px-4 py-2 font-medium border-b-2 transition-colors ${
            activeTab === 'sales' 
              ? 'border-blue-600 text-blue-600' 
              : 'border-transparent text-gray-500 hover:text-gray-700'
          }`}
        >
          <FileText className="w-4 h-4 inline mr-2" />
          Satış Sözleşmesi
        </button>
        <button
          onClick={() => setActiveTab('distance')}
          className={`px-4 py-2 font-medium border-b-2 transition-colors ${
            activeTab === 'distance' 
              ? 'border-blue-600 text-blue-600' 
              : 'border-transparent text-gray-500 hover:text-gray-700'
          }`}
        >
          <FileText className="w-4 h-4 inline mr-2" />
          Mesafeli Satış Sözleşmesi
        </button>
      </div>

      {/* Editor / Preview */}
      <Card>
        <CardHeader className="flex flex-row items-center justify-between py-3">
          <CardTitle className="text-lg">
            {activeTab === 'sales' ? 'Satış Sözleşmesi' : 'Mesafeli Satış Sözleşmesi'}
          </CardTitle>
          <Button 
            variant="ghost" 
            size="sm"
            onClick={() => handleReset(activeTab)}
            className="text-gray-500 hover:text-gray-700"
          >
            <RefreshCcw className="w-4 h-4 mr-1" />
            Varsayılana Dön
          </Button>
        </CardHeader>
        <CardContent>
          {previewMode ? (
            <div className="bg-gray-50 p-6 rounded-lg border max-h-[600px] overflow-y-auto">
              <pre className="whitespace-pre-wrap font-sans text-sm text-gray-700 leading-relaxed">
                {getPreviewText(activeTab === 'sales' ? salesAgreement : distanceAgreement)}
              </pre>
            </div>
          ) : (
            <textarea
              value={activeTab === 'sales' ? salesAgreement : distanceAgreement}
              onChange={(e) => activeTab === 'sales' ? setSalesAgreement(e.target.value) : setDistanceAgreement(e.target.value)}
              className="w-full h-[600px] p-4 border rounded-lg font-mono text-sm resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Sözleşme metnini buraya yazın..."
            />
          )}
        </CardContent>
      </Card>
    </div>
  );
}
